export enum ServiceCertificateTypeEnum {
    SUKL = 'SUKL',
}
